interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "IDR";
};

const IDR: Currency = Object.freeze({
  "displayName": "Indonesian Rupiah",
  "numericCode": 360,
  "defaultFractionDigits": 0,
  "subUnit": 1,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "IDR",
  "symbol": "Rp"
});

export { IDR };
